import Cookies from 'js-cookie';
import { QueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

export const doLogout = (
  navigate: NavigateFunction,
  queryClient: QueryClient,
) => {
  queryClient.removeQueries();
  const domain = window.location.hostname.replace(/(.*\.)?([^.]*\..*)/, '$2');
  Cookies.set('uid', '', {
    expires: new Date(0),
    path: '/',
    domain: domain,
  });
  Cookies.set('gbadmin_token', '', {
    expires: new Date(0),
    path: '/',
    domain: domain,
  });
  Cookies.set('gb_bubbly_cookie', '', {
    expires: new Date(0),
    path: '/',
    domain: domain,
  });
  Cookies.set('bubble_token', '', {
    expires: new Date(0),
    path: '/',
    domain: domain,
  });
  Cookies.remove('class');
  Cookies.remove('user_type');
  Cookies.remove('is_login');
  localStorage.removeItem('LOGGING_IN');
  localStorage.removeItem('trial_subs');
  localStorage.removeItem('exp_subs_date');
  Cookies.remove('gb_ci_session');
  Cookies.remove('is_vn_student');
  navigate('/');
};
